import { ROUTE_PATH } from './consts';

export const createQuestionEditPageUrl = questionId =>
  ROUTE_PATH.replace(':questionId', questionId);
